export default async ({ $axios, store }) => {
  if (!store.state.settings) {
    try {
      const settings = await $axios.$get('/setting/public')
      store.commit('saveSetting', settings)
    } catch (error) { }
  }
}
